import { defineComponent as _defineComponent } from 'vue'
import BCXQuickLayer from '@/components/molecules/BCXQuickLayer.vue';
import { computed, PropType, ref } from 'vue';
import BCXDatePicker from '@/components/molecules/forms/datepicker/BCXDatePicker.vue';
import X from '@/components/svg-components/X.vue';
import { BcxDatePickerTimeLevel } from '@/models/BcxDatePicker';
import useResponsiveness from '@/mixins/useResponsiveness';
import useFormattedDateTime from '@/mixins/useFormattedDateTime';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXDatepickerField',
  props: {
  value: {
    type: String as PropType<string>,
    default: ''
  },
  earliest: {
    type: [String, Date] as PropType<string | Date | null>,
    default: null
  },
  latest: {
    type: [String, Date] as PropType<string | Date | null>,
    default: null
  },
  isSecondary: Boolean,
  disabled: {
    type: Boolean,
    default: false
  },
  invalid: {
    type: Boolean
  },
  showArrow: {
    type: Boolean,
    default: false
  },
  arrowStep: {
    type: Number,
    default: 1
  },
  proposedDate: {
    type: [String, Date] as PropType<string | Date>,
    default: null
  },
  showX: {
    type: Boolean,
    default: false
  }
},
  emits: ['input'],
  setup(__props, { emit }) {

const props = __props;





const { isSmartphoneWidth, isMobileWidth } = useResponsiveness();

const { getFormattedDate } = useFormattedDateTime();

const isOpen = ref(false);

const prettyDate = computed(() => getFormattedDate(props.value));

const onFocusField = () => {
  isOpen.value = true;
};

const onSelectTimelevel = (timeLevel: BcxDatePickerTimeLevel) => {
  if (timeLevel === BcxDatePickerTimeLevel.MONTH) isOpen.value = false;
};

// value field will always be kept as a string, no matte what format was given initially:
const vmValueDate = computed({
  get: () => props.value || props.earliest || new Date(),
  set: (value: Date | null | string) => {
    if (!value) {
      emit('input', '');
    } else if (typeof value === 'string') {
      emit('input', value);
    } else {
      emit('input', value.toISOString().slice(0, 10));
    }
  }
});

/**
 * Adds or subtracts days from the current date.
 * @param step Number of days to change (e.g. 1 or -1)
 */
function changeDate(step: number) {
  const date = new Date(vmValueDate.value);
  date.setDate(date.getDate() + step);
  if (date < new Date(props.earliest || '') || date > new Date(props.latest || '')) return;
  vmValueDate.value = date;
}

function clearInput() {
  vmValueDate.value = '';
}

return { __sfc: true,props, emit, isSmartphoneWidth, isMobileWidth, getFormattedDate, isOpen, prettyDate, onFocusField, onSelectTimelevel, vmValueDate, changeDate, clearInput, BCXQuickLayer, BCXDatePicker, X }
}

})